export default __webpack_public_path__ + "9621e1ac2ccfe9804f5a9cdb7aa00ecb.png";